import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const CONTENT = {
  '/privacy': {
    title: 'Privacy Policy',
    intro: "FIVETRY Fashion & Lifestyle (\u201cwe\u201d, \u201cus\u201d) respects your privacy. This policy explains what information we collect when you use our website and home-trial service, and how we use it.",
    sections: [
      { h: 'What we collect', p: ['When you book a trial, we collect your name, phone number, delivery address, the items you select, and your order history. We do not collect any payment card or bank details.'] },
      { h: 'How we use your information', p: ['We use your details only to deliver and manage your trial, contact you about your order, process payment for the items you choose to keep, and improve our service. We never sell or rent your information to third parties.'] },
      { h: 'Payments', p: ['Payments are made directly through your own UPI app. FIVETRY does not see or store your UPI PIN, card, or bank details.'] },
      { h: 'Storage & security', p: ['Your information is stored securely using Google Firebase. We take reasonable steps to protect it from unauthorised access.'] },
      { h: 'Sharing', p: ['We share your address and contact details only with our delivery partners, strictly to fulfil your order, and where required by law.'] },
      { h: 'Your choices', p: ['You can ask us to view, correct, or delete the information we hold about you at any time by contacting us.'] },
      { h: 'Contact', p: ['Questions about your privacy? WhatsApp us at 8108885858 or email 5ivetry@gmail.com.'] },
    ],
  },
  '/terms': {
    title: 'Terms & Conditions',
    intro: 'By using the FIVETRY website and home-trial service, you agree to the following terms.',
    sections: [
      { h: 'How FIVETRY works', p: ['You can add up to 5 items to your Try Bag and book a next-day home trial in your chosen time slot. Our delivery partner brings the items to you, and you have time to try them on at home. You pay only for the items you choose to keep.'] },
      { h: 'Pricing & discounts', p: ['All prices are in Indian Rupees (\u20b9). A keep-more discount is applied automatically to the items you keep: 5% on 1 item, 10% on 2 items, and 20% on 3 or more items.'] },
      { h: 'Payment', p: ['Payment for items you keep is made at the time of your trial through UPI. Items remain the property of FIVETRY until full payment is received.'] },
      { h: 'Availability', p: ['Home trials are currently available in Thane West and nearby areas (within roughly 10 km). You or someone you authorise must be present at the delivery address during your selected slot.'] },
      { h: 'Returns', p: ['Any items you do not wish to keep are handed back to our delivery partner during the trial, at no cost to you.'] },
      { h: 'Cancellation & rescheduling', p: ['You may cancel or reschedule your trial before delivery by messaging us on WhatsApp.'] },
      { h: 'Product information', p: ['We make every effort to display product images, sizes, and details accurately. Slight variation in colour may occur due to screen and lighting differences.'] },
      { h: 'Changes to these terms', p: ['We may update these terms from time to time. Continued use of FIVETRY means you accept the latest version.'] },
      { h: 'Contact', p: ['WhatsApp 8108885858 or email 5ivetry@gmail.com.'] },
    ],
  },
  '/returns': {
    title: 'Return Policy',
    intro: 'Because FIVETRY is try-before-you-buy, returns are simple \u2014 you only ever pay for what you keep.',
    sections: [
      { h: 'During your trial', p: ['Try everything at home. Hand any items you don\u2019t want back to our delivery partner during the trial. There is no charge and no questions asked for items returned at this stage.'] },
      { h: 'After you keep & pay', p: ['If an item you kept turns out to be defective or the wrong size, contact us within 48 hours of your trial with your Booking ID and a photo. We\u2019ll arrange an exchange or a refund.'] },
      { h: 'Condition', p: ['To be eligible, items must be unworn (beyond trying on), unwashed, undamaged, and have their original tags attached.'] },
      { h: 'Refunds', p: ['Approved refunds are processed to your original payment method within 5\u20137 business days after we receive and check the returned item.'] },
      { h: 'Contact', p: ['WhatsApp 8108885858 or email 5ivetry@gmail.com.'] },
    ],
  },
  '/delivery': {
    title: 'Delivery Information',
    intro: 'Everything you need to know about FIVETRY home trials and delivery.',
    sections: [
      { h: 'Where we deliver', p: ['We currently serve Thane West and surrounding areas, within roughly a 10 km radius. We\u2019re expanding, so check back as we grow.'] },
      { h: 'When', p: ['We offer next-day delivery. Choose the slot that suits you: 12\u20133 PM, 3\u20136 PM, or 6\u20139 PM.'] },
      { h: 'Your home trial', p: ['Our delivery partner brings your selected items to your door so you can try them on in the comfort of your home.'] },
      { h: 'Free delivery & pickup', p: ['Delivery and the pickup of any returned items are completely free.'] },
      { h: 'Paying for what you keep', p: ['Pay via UPI for the items you love. Anything you don\u2019t keep goes straight back with our delivery partner.'] },
      { h: 'Contact', p: ['WhatsApp 8108885858 or email 5ivetry@gmail.com.'] },
    ],
  },
};

export default function LegalPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const data = CONTENT[location.pathname];

  if (!data) {
    return (
      <div style={{ minHeight: '100vh', background: '#fafaf7', fontFamily: 'Arial', padding: '60px 24px', textAlign: 'center' }}>
        <p style={{ color: '#666' }}>Page not found.</p>
        <button onClick={() => navigate('/')} style={{ background: '#1a1a1a', color: 'white', border: 'none', padding: '12px 28px', borderRadius: '10px', fontSize: '13px', letterSpacing: '1px', cursor: 'pointer', marginTop: '16px' }}>BACK TO HOME</button>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf7', fontFamily: 'Arial', paddingBottom: '110px' }}>

      {/* NAVBAR */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fafaf7', borderBottom: '0.5px solid #eeeae3', display: 'flex', alignItems: 'center', padding: '18px 24px' }}>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
          <span onClick={() => navigate(-1)} style={{ cursor: 'pointer', fontSize: '20px', color: '#1a1a1a', padding: '4px 8px' }}>←</span>
        </div>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <h1 onClick={() => navigate('/')} style={{ margin: 0, fontSize: '22px', fontWeight: '500', color: '#1a1a1a', fontFamily: '"Playfair Display", Georgia, serif', letterSpacing: '6px', paddingLeft: '6px', cursor: 'pointer' }}>FIVETRY</h1>
        </div>
        <div style={{ flex: 1 }} />
      </div>

      {/* CONTENT */}
      <div style={{ maxWidth: '640px', margin: '0 auto', padding: '36px 24px' }}>
        <h2 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '30px', fontWeight: '500', color: '#1a1a1a', margin: '0 0 6px' }}>{data.title}</h2>
        <div style={{ fontSize: '12px', color: '#9c7d4f', letterSpacing: '1px', marginBottom: '22px' }}>Last updated: May 2026</div>

        <p style={{ fontSize: '15px', color: '#555', lineHeight: '1.7', marginBottom: '28px' }}>{data.intro}</p>

        {data.sections.map((sec, i) => (
          <div key={i} style={{ marginBottom: '24px' }}>
            <h3 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '18px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 8px' }}>{sec.h}</h3>
            {sec.p.map((para, j) => (
              <p key={j} style={{ fontSize: '14px', color: '#555', lineHeight: '1.7', margin: '0 0 10px' }}>{para}</p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}